import React , {Component} from 'react';
import { Route, Link } from "react-router-dom";
import $ from 'jquery'
import './Navigation.css'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()
class Navigation extends Component{


  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
      console.log(event.target.value, event.target.name)
      this.setState({
        ...this.state,
        [event.target.name]: event.target.value
      });
  }


  state  = {
    logging_in_error: false,
    logging_in_error_msg: "",
    logging_in: false,
    login_email : "",
    login_password : "",

    signing_up:false,
    signup_firstname: "",
    signup_lastname: "",
    signup_email: "",
    signup_password: "",
    signup_confirm_password: "",
    signup_affiliation: "",
    signup_responsibility: "",
    signup_error: false,
    signup_error_msg: "",
    signup_success_msg: "",
    endpoint: 'https://vims.cis.udel.edu/geography/seaice/services/',
  }

  closePopup = () => {
    this.setState({
      signup_in_error: false,
      logging_in_error: false,
      signup_error_msg:"",
      logging_in_error_msg:"",
      logging_in: false,
      signing_up:false
    })
  }

  logggingIn = () => {
    this.setState({
       logging_in_error: false,
       logging_in: true,
       signing_up:false
    })
  }

  signingUp = () => {
    this.setState({
       signup_in_error: false,
       logging_in: false,
       signing_up: true
    })
  }


  signOut = () => {
    localStorage.clear();
    localStorage.setItem('logged_in', false)
    this.setState({
      logging_in: false,
      signing_up:false,
      logging_in_error: false,
      signup_in_error: false,
      login_email : "",
      login_password : ""
    })
    window.location.reload(false);

  }

  responsiveNavBar = () => {
      var x = document.getElementById("nav");
      if(x.className === 'responsive'){
        x.className = "nav row"
      }else{
        x.className = "responsive"
      }
  }

  /*
    Paint Nav Link according to onClick
    Paint choosen link to black
    Set its text to white
    All other links are set to white
    Set its text to black
  */

  paintNavLink = (choosen_link) => {
    console.log('choosen_link' + choosen_link)
    let links = ['#Home', '#Documentation','#Collabrate'];
    for (let index in links){
        if(links[index] === choosen_link){
          $(links[index]).children().css('color','#15f4ee');
        }else{
          $(links[index]).children().css('color','white');
        }
    }
  }

  validateName = (name) => {
    if(/^[A-Za-z\s]+$/.test(name)){
      return true;
    }
    return false;
  }


  validateEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
      return true
    }
    return false
  }

  validatePassword = (password)  => {
      if (password.match(/[a-z]/g) && password.match(/[A-Z]/g) && password.match(/[0-9]/g) && password.match(/[^a-zA-Z\d]/g) && password.length >= 8){
        return true;
      }
      return false;
    }

  validateConfirmPassword  = (password, confirm_password) => {
    if(password === confirm_password){
      return true;
    }
    return false;
  }



  authenticate = () => {
    if (this.state.login_email !== "" && this.state.login_password !== ""){
      if(this.validateEmail(this.state.login_email)){
        let form_data = new FormData();
        form_data.append('email', this.state.login_email)
        form_data.append('password', this.state.login_password)
        let url = this.state.endpoint + 'authenticateusr/'
        axios.request({
          method: 'post',
          url: url,
          data: form_data
        }).then( (response) => {
          console.log(response.data)
          if(response.data['Response'] === 1){
            console.log('Logged In')
            console.log(response.data['data'])
            localStorage.setItem('logged_in', true)
            localStorage.setItem('first_name', response.data['data']['first_name'])
            localStorage.setItem('last_name', response.data['data']['last_name'])
            localStorage.setItem('email', response.data['data']['email'])
            localStorage.setItem('affiliation', response.data['data']['affiliation'])
            localStorage.setItem('responsibility', response.data['data']['responsibility'])
            localStorage.setItem('api_key', response.data['data']['api_key'])

            this.setState({
              logging_in: false,
              signing_up: false,
              login_email : "",
              logging_in_error: false,
              logging_in_error_msg: "",
              login_password : "",
            })
            window.location.reload(false);

          }else if(response.data['Response'] === 0){
            console.log('Failed')
            localStorage.setItem('logged_in', false)
            this.setState({
              logging_in: true,
              signing_up: false,
              logging_in_error: true,
              logging_in_error_msg: "Email and password do not match",
            })
          }else{
            this.setState({
              logging_in_error: true,
              logging_in_error_msg: "Error. Please try again or send an email to vims@cis.udel.edu"
            });
          }
        })
        .catch((error) => {
          this.setState({
            logging_in_error: true,
            logging_in_error_msg: "Error. Please try again or send an email to vims@cis.udel.edu"
          });
        });
      }else{
        this.setState({
          logging_in_error: true,
          logging_in_error_msg: "Not a valid e-mail address!"
        });
      }
    }else{
      this.setState({
        logging_in_error: true,
        logging_in_error_msg: "E-mail or password cannot be empty!"
      });
    }
  }

  signup = () => {
    console.log(this.state.signup_error_msg)
    if ((this.state.signup_firstname !== "") &&  (this.state.signup_lastname !== "") && (this.state.signup_email !== "") && (this.state.signup_password !== "") &&
        (this.state.signup_confirm_password !== "") && (this.state.signup_affiliation !== "") && (this.state.signup_responsibility !== "")){
          if(this.validateName(this.state.signup_firstname) && this.validateName(this.state.signup_lastname)){
            if(this.validateEmail(this.state.signup_email)){
              if(this.validatePassword(this.state.signup_password)){
                if(this.validateConfirmPassword(this.state.signup_password, this.state.signup_confirm_password)){
                  let form_data = new FormData();
                  form_data.append('first_name', this.state.signup_firstname)
                  form_data.append('last_name', this.state.signup_lastname)
                  form_data.append('email', this.state.signup_email)
                  form_data.append('password', this.state.signup_password)
                  form_data.append('affiliation', this.state.signup_affiliation)
                  form_data.append('responsibility', this.state.signup_responsibility)

                  let url = this.state.endpoint + 'createusr/'
                  axios.request({
                    method: 'post',
                    url: url,
                    data: form_data
                  }).then( (response) => {
                    console.log(response.data)
                    if(response.data['Response'] === 1){
                      this.setState({
                        signup_error: false,
                        signing_up:false,
                        signup_firstname: "",
                        signup_lastname: "",
                        signup_email: "",
                        signup_password: "",
                        signup_confirm_password: "",
                        signup_affiliation: "",
                        signup_responsibility: "",
                        signup_error_msg: ""
                      });
                      toast('Please check your email to verify your account.', { autoClose: 3000, hideProgressBar: true })
                    }else if(response.data['Response'] === 0){
                      this.setState({
                        signup_error: true,
                        signup_error_msg: "E-mail already exists. Did you want to login instead?"
                      });
                    }else{
                      this.setState({
                        signup_error: true,
                        signup_error_msg: "Error. Please try again or send an email to vims@cis.udel.edu"
                      });
                    }
                  })
                  .catch((error) => {
                    this.setState({
                      signup_error: true,
                      signup_error_msg: "Error. Please try again or send an email to vims@cis.udel.edu"
                    });
                  });
                }else{
                  this.setState({
                    signup_error: true,
                    signup_error_msg: "Confirmed password does not match original password!",
                  });
                }
              }else{
                this.setState({
                  signup_error: true,
                  signup_error_msg: "Password must contain at least one number, one uppercase and lowercase letter, one special character and 8 characters!",
                });
              }
            }else{
              this.setState({
                signup_error: true,
                signup_error_msg: "Invalid email!",
              });
            }
          }else{
            this.setState({
              signup_error: true,
              signup_error_msg: "Invalid name!",
            });
          }
    }else{
      this.setState({
        signup_error: true,
        signup_error_msg: "No form field can be empty!",
      });
    }

  }

  render(){

    let logged_in = JSON.parse(localStorage.getItem('logged_in'));
    console.log(logged_in)
    return(



      <div>
              <div>
                { this.state.logging_in ?
                  <div id="myModal" class="modal-login">
                    <div class="modal-login-content">
                      <div className = 'close-div'>
                      <p className="close" onClick = {() => this.closePopup()}>&times;</p>
                      </div>
                      <label>
                        <input name= "login_email" placeholder = "E-mail" type="text" value={this.state.value} onChange={this.handleChange} />
                      </label>
                      <label>
                        <input name= "login_password" placeholder = "Password" type="password" value={this.state.value} onChange={this.handleChange} />
                      </label>
                      {this.state.logging_in_error?
                        <div className = "modal-login-error">
                          <p> {this.state.logging_in_error_msg} </p>
                          </div>:null
                      }
                      <button onClick = {() => this.authenticate()}>Login</button>
                    </div>
                  </div>
              :null}
            </div>


            <div>
              { this.state.signing_up ?
                <div id="myModal" class="modal-signup">
                  <div class="modal-signup-content">
                    <div className = 'close-div'>
                    <p className="close" onClick = {() => this.closePopup()}>&times;</p>
                    </div>
                    <label>
                      <input name= "signup_firstname" placeholder = "First Name" type="text" value={this.state.value} onChange={this.handleChange} />
                    </label>
                    <label>
                      <input name= "signup_lastname" placeholder= "Last Name" type="text" value={this.state.value} onChange={this.handleChange} />
                    </label>
                    <label>
                      <input name= "signup_email" placeholder = "E-mail" type="email" value={this.state.value} onChange={this.handleChange} />
                    </label>
                    <label>
                      <input name= "signup_password" placeholder = "Password" type="password" value={this.state.value} onChange={this.handleChange}/>
                    </label>
                    <label>
                      <input name= "signup_confirm_password" placeholder = "Confirm Password" type="password" value={this.state.value} onChange={this.handleChange} />
                    </label>
                    <label>
                      <input name= "signup_affiliation" placeholder = "Affiliation (Name of University, Company, etc.)" type="text" value={this.state.value} onChange={this.handleChange} />
                    </label>
                    <label>
                      <input name= "signup_responsibility" placeholder = "Role in Affiliation" type="text" value={this.state.value} onChange={this.handleChange} />
                    </label>
                    {this.state.signup_error?
                      <div className = "modal-signup-error">
                        <p> {this.state.signup_error_msg}</p>
                        </div>:null
                    }
                    <button onClick = {() => this.signup()}>SignUp</button>
                  </div>
                </div>
            :null}
          </div>

          <div>
          { !logged_in?
          <ul className = 'login'>
              <Link>
                <li onClick = {() => this.signingUp()}  >
                  SignUp
                </li>
              </Link>
              <Link>
                <li onClick = {() => this.logggingIn()} >
                  Login
                </li>
              </Link>
          </ul>:

          <ul className = 'login'>
              <Link>
                <li onClick = {() => this.signOut()}  >
                  SignOut
                </li>
              </Link>
          </ul>
        }

          </div>


        <nav id = "nav" className = "nav">
          <ul>
              <Link id = "Home" to = "/geo/ice/Home/">
                <li onClick = {() => this.paintNavLink('#Home')} >
                  Home
                </li>
              </Link>
              <Link id = "Documentation" to = "/geo/ice/documentation">
                <li onClick = {() => this.paintNavLink('#Documentation')}  >
                  Documentation
                </li>
              </Link>
              <Link id = "Collabrate" to = "/geo/ice/collaborate">
                <li onClick = {() => this.paintNavLink('#Collabrate')}  >
                  Collaborate
                </li>
              </Link>
          </ul>
        </nav>
      </div>
    )
  }

  componentDidMount(){
    this.paintNavLink('#Home');
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js